// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { onePageCheckoutShippingSectionStyles } from "@conklin/Overrides/Widgets/OnePageCheckout/OnePageCheckoutShippingSection";
import { css } from "styled-components";

onePageCheckoutShippingSectionStyles.titleEditLink = {
    typographyProps: {
        size: 12,
        lineHeight: "15px",
        css: css`
            &&& {
                line-height: 15px;
            }
        `,
    },
    css: css`
        margin-left: 24px;
    `,
};

onePageCheckoutShippingSectionStyles.billToGridItem = {
    css: css`
        margin-bottom: 16px;
    `,
};
onePageCheckoutShippingSectionStyles.shipToGridItem = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 16px;
    `,
};

onePageCheckoutShippingSectionStyles.useShippingAddressGridItem = {
    css: css`
        margin-bottom: 16px;
    `,
};

onePageCheckoutShippingSectionStyles.saveButton = {
    sizeVariant: "small",
    css: css`
        margin: 16px 0;
    `,
};

onePageCheckoutShippingSectionStyles.saveBillToButton = {
    sizeVariant: "small",
    css: css`
        margin: 4px 0 12px;
    `,
};
